/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 11:52:57
 */
import { Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import { ExceptionParams } from "../../services/exception";
import { ExceptionMessageColumn } from "./columns";
import styles from "./ExceptionMessage.module.css";
import {
  getExceptionListAsync,
  selectExceptionList,
} from "./ExceptionMessageSlice";
import { ExceptionDetailModal } from "./modal";
import { ExceptionMessageQuerys } from "./query";

export const ExceptionListMessage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [id, setId] = useState("");

  const [queries, setQueries] = useState<ExceptionParams>({
    pn: 1,
    ps: 10,
  });

  const page = useSelector(selectExceptionList);

  useEffect(() => {
    dispatch(
      getExceptionListAsync({
        ...queries,
        ruleMainCode: queries.ruleMainCode || undefined,
      })
    );
  }, [dispatch, queries]);
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flex: 1,
            background: "#fff",
            borderRadius: 10,
            padding: 20,
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
          <ExceptionMessageQuerys
            onValueChange={(v) => {
              setQueries({ ...v, pn: 1, ps: 10 });
            }}
          />
        </div>
      </div>
      <div
        style={{ height: "calc(100% - 130px)" }}
        className={styles.exceptionMessage}
      >
        <div
          style={{
            width: "100%",
            height: "calc(100% - 55px)",
            overflow: "auto",
          }}
        >
          <Table
            rowKey={(record) => record.cautionId}
            className={styles.exceptionMessageTable}
            pagination={false}
            style={{ height: "100%" }}
            dataSource={page.records}
            columns={ExceptionMessageColumn((text, id) => {
              if (text === "look") {
                setId(id.toString());
              }
            }, page.size * (page.current - 1))}
            onRow={(record) => ({
              onDoubleClick: () => setId(record?.cautionId?.toString() || ""),
            })}
          />
          <Pagination
            total={page.total}
            current={page.current}
            pageSize={page.size}
            showSizeChanger
            showQuickJumper
            style={{
              position: "absolute",
              bottom: "40px",
              right: "40px",
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={(current, size) => {
              setQueries({ ...queries, pn: current, ps: size });
            }}
          />
        </div>
        <ExceptionDetailModal
          id={id}
          visible={!!id}
          onCancel={() => {
            setId("");
          }}
          onOk={() => {
            setId("");
          }}
        />
      </div>
    </div>
  );
};
